import React from 'react';
import { getFormattedEasternDateTime, getFormattedStringDate } from '../common/util';
import { SdfBox, SdfCheckbox, SdfDatePicker, SdfIcon, SdfSwitch } from '@synerg/react-components';
import { getInputDate } from './milestones';


export function StartCompactMilestone({ project = {}, date, onChangeDate = () => { } }) {
	return (
		<div className="milestone h-full">
			<SdfBox
				shape="rounded"
				variant="shadowed"
				spacing="loose"
				className="milestone-shadow h-full"
			>

				<div className="text-sm">Milestone</div>
				<div className="flex mt-2 justify-between gap-8">
					<div className="text-heading-04 font-bold">Project start date</div>
				</div>

				<div className="mt-6 w-1/3">
					<SdfDatePicker
						label="Start date"
						disabled={Boolean(project.link)}
						placeholder="mm/dd/yyyy"
						className="w-full"
						value={date}
						onSdfChange={(e) => onChangeDate(e.detail)}
					>
					</SdfDatePicker>
				</div>
			</SdfBox>
		</div>
	);
}


function CompactMilestone({ actions, milestone, lastChanges }) {


	return (<>
		<div className="milestone h-full">
			<SdfBox
				shape="rounded"
				variant="shadowed"
				spacing="loose"
				className="milestone-shadow h-full"
			>

				<div className="text-sm">Milestone</div>
				<div className="flex mt-2 justify-between gap-8">
					<div className="text-heading-04 font-bold">{milestone.name}</div>
					<div className="flex justify-between milestone items-center">
						{lastChanges.scope &&
							<div className="last-modified">Last modified by {lastChanges.scope.name} on {lastChanges.scope.date}</div>
						}
						<SdfSwitch
							checked={milestone.scope}
							slot="action"
							className="cursor-pointer ml-4"
							{... (milestone.scopeDisabled) && { disabled: true }}
							onSdfChange={() => { actions.setScope({ id: milestone.id, value: !milestone.scope }); }} >
							{milestone.scope ? <SdfIcon icon="action-confirm" style={{ position: 'absolute', right: '12px', fontSize: '12px' }} /> :
								<SdfIcon icon="action-close" style={{ position: 'absolute', left: '4px', fontSize: '12px' }} />
							}
						</SdfSwitch>
						<div className="text-heading-01 font-bold">{milestone.scope ? 'In scope' : 'Out of scope'}</div>
					</div>
				</div>

				<div className="mt-6 flex gap-5">
					<div className="w-1/3">
						<SdfDatePicker
							label="Start date"
							disabled={milestone.startDateDisabled}
							placeholder="mm/dd/yyyy"
							className="w-full"
							value={getInputDate(milestone.startDate)}
							onSdfChange={(e) => actions.setStartDate({ id: milestone.id, value: getFormattedStringDate(e.detail) })}>
						</SdfDatePicker>

						{lastChanges.startDate && <>
							<div className="last-modified">Last modified by: {lastChanges.startDate.name} on {lastChanges.startDate.date}</div>
						</>}
					</div>

					<div className="w-1/3">
						<SdfDatePicker
							label="End date"
							disabled={milestone.endDateDisabled}
							value={getInputDate(milestone.endDate)}
							placeholder="mm/dd/yyyy"
							className="w-full"
							onSdfChange={(e) => { actions.setEndDate({ id: milestone.id, value: getFormattedStringDate(e.detail) }) }}
							rules={milestone.startDate ? [{ type: "ENABLED", startDateInclusive: getInputDate(milestone.startDate) }] : []}
						>
						</SdfDatePicker>

						{lastChanges.endDate && <>
							<div className="last-modified">Last modified by: {lastChanges.endDate.name} on {lastChanges.endDate.date}</div>
						</>}

					</div>

					<div className="pt-8 ml-auto text-right w-3/12">
						<SdfCheckbox
							label="Done"
							checked={milestone.complete}
							{... (milestone.completeDisabled) && { disabled: true }}
							onSdfChange={() => actions.setComplete({ id: milestone.id, value: !milestone.complete })}
						>
						</SdfCheckbox>

						{lastChanges.complete &&
							<div className="last-modified">Last modified by {lastChanges.complete.name} on {lastChanges.complete.date}</div>
						}
					</div>
				</div>
			</SdfBox>
		</div>
	</>
	);
}

export function Milestone({ actions, milestone }) {
	const { startDateLastChange, endDateLastChange, scopeLastChange, completeLastChange } = milestone;
	const lastChanges = {};
	const getModifiedBy = (name, date) => {
		return { name, date: getFormattedEasternDateTime(date) }
	}

	if (startDateLastChange.user) {
		const { date, user: { name } } = startDateLastChange;
		lastChanges.startDate = getModifiedBy(name, date);
	}

	if (endDateLastChange.user) {
		const { date, user: { name } } = endDateLastChange;
		lastChanges.endDate = getModifiedBy(name, date);
	}

	if (scopeLastChange.user) {
		const { date, user: { name } } = scopeLastChange;
		lastChanges.scope = getModifiedBy(name, date);
	}

	if (completeLastChange.user) {
		const { date, user: { name } } = completeLastChange;
		lastChanges.complete = getModifiedBy(name, date);
	}

	const milestoneProps = { actions, milestone, lastChanges };

	return <CompactMilestone {...milestoneProps} />
}
